import React from 'react';
import ReactDOM from 'react-dom';
import { applyMiddleware, compose, createStore } from 'redux'
import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'
import { Provider } from 'react-redux'
import createSagaMiddleware from 'redux-saga'
import * as serviceWorker from './serviceWorker';
import './index.css';
import rootReducer from './reducers';
import App from "./App";
import mySaga from "./sagas";

const history = createBrowserHistory();

const sagaMiddleware = createSagaMiddleware();

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
    rootReducer(history),
    composeEnhancer(
        applyMiddleware(
            routerMiddleware(history),
        ),
        applyMiddleware(sagaMiddleware),
    ),
);

const render = () => {
    ReactDOM.render(
            <Provider store={store}>
                <App history={history} />
            </Provider>,
        document.getElementById('root')
    )
};


sagaMiddleware.run(mySaga);

render();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
